import { render } from "./Workorder_GDDB.vue?vue&type=template&id=5eb98b5b&scoped=true"
import script from "./Workorder_GDDB.vue?vue&type=script&lang=js"
export * from "./Workorder_GDDB.vue?vue&type=script&lang=js"

import "./Workorder_GDDB.vue?vue&type=style&index=0&id=5eb98b5b&scoped=true&lang=css"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb98b5b"]])

export default __exports__